import * as z from 'zod';

import { BankRoutingNumber } from '../BankAccount';

/**
 * Lender-controlled settings for NACHA file generation.
 */
export const CompanyNachaSettings = z.object({
  // When true, the generated NACHA file includes an offsetting settlement entry against the
  // company's account so total debits equal total credits (a "balanced" file). When false the
  // file is "unbalanced" — only receiver entries are sent and the ODFI posts the offset
  produceBalancedFile: z.boolean().optional(),
  // Overrides for NACHA file/batch header fields. Each is optional; when unset (or blank) the
  // generator falls back to the value noted below. Optional so existing persisted blobs parse.
  // Company Identification (batch header) — falls back to the company EIN.
  companyIdentification: z.string().optional(),
  // Immediate Origin Name (file header) — falls back to the company name.
  companyName: z.string().optional(),
  // Immediate Destination (file header) — falls back to the originating bank account routing number.
  immediateDestination: BankRoutingNumber.optional(),
  // Immediate Origin (file header) — falls back to the originating bank account routing number.
  immediateOrigin: BankRoutingNumber.optional(),
});
export type CompanyNachaSettings = z.infer<typeof CompanyNachaSettings>;

export const DEFAULT_COMPANY_NACHA_SETTINGS: CompanyNachaSettings = {
  produceBalancedFile: true,
};
